import { useState } from 'react';
import { isEqual } from 'lodash';

import { MetaPages } from '../../enums/pages';
import ShowroomRadioButtons from '../../components/organisms/showroom-radio-buttons/showroom-radio-buttons';
import ShowroomLocation from '../../components/atoms/showroom-location/showroom-location';
import {
  getShowroomContent,
  getShowroomCoordinatesContent
} from '../../services/showroom';
import {
  ShowroomCoordinatesType,
  ShowroomDetailsType
} from '../../types/showroom';
import SzwfMaps from '../../components/organisms/szwf-maps/szwf-maps';
import SectionTitle from '../../components/atoms/section-title/section-title';
import MarginSpacing from '../../components/atoms/margin-spacing/margin-spacing';
import HeaderContainer from '../../components/molecules/header-container/header-container';
import { getAboutBannerContent } from '../../services/about';
import Tabs from '../../components/molecules/tabs/tabs';
import { aboutRoutes } from '../../config/routes/pages';
import { ContentType } from '../../types/content';
import { ShowroomContentTabs } from '../../enums/contentTabs';
import TabTitle from '../../components/atoms/tab-title/tab-title';

type IndexProps = {
  aboutBannerContent: ContentType;
  showroomContent: ShowroomDetailsType[];
  showroomCoordinatesContent: ShowroomCoordinatesType[];
};

export function Index(props: IndexProps) {
  const { aboutBannerContent, showroomContent, showroomCoordinatesContent } =
    props;

  const [MakatiMapCoordinate] = showroomCoordinatesContent;

  const [showroomCoordinates, setShowroomCoordinates] =
    useState(MakatiMapCoordinate);

  function onClickChangeCoordinates(newCoordinates: any) {
    setShowroomCoordinates(newCoordinates);
  }

  const filteredShowroomContent = showroomContent.filter((showroomItem) => {
    return isEqual(showroomCoordinates.locationName, ShowroomContentTabs.ALL)
      ? showroomContent
      : isEqual(
          showroomItem.showroomLocation,
          showroomCoordinates.locationName
        );
  });

  const showrooms = filteredShowroomContent.map((showroomItemDetails) => (
    <ShowroomLocation
      key={showroomItemDetails.showroomLocation}
      {...showroomItemDetails}
    />
  ));

  return (
    <>
      <TabTitle page={MetaPages.ABOUT_SHOWROOM} />
      <HeaderContainer {...aboutBannerContent} />
      <Tabs tabItems={aboutRoutes} />
      <MarginSpacing margin="mt-14" />
      <SectionTitle title="VISIT OUR SHOWROOMS" />
      <div className="px-5">
        <ShowroomRadioButtons
          activeShowroom={showroomCoordinates}
          coordinateDetails={showroomCoordinatesContent}
          onClick={onClickChangeCoordinates}
        />
        <SzwfMaps coordinates={showroomCoordinates} />
      </div>
      {showrooms}
    </>
  );
}

export async function getStaticProps() {
  const aboutBannerContent = await getAboutBannerContent();
  const showroomContent = await getShowroomContent();
  const showroomCoordinatesContent = await getShowroomCoordinatesContent();

  return {
    props: {
      aboutBannerContent,
      showroomContent,
      showroomCoordinatesContent
    }
  };
}

export default Index;
